import navCatalogsItems from './catalogs';
import navWarningsItems from './warning_models';
import navAnalistItems from './analist_models';
import { hasPermissions } from 'utils/permissions';

const items = [];

if (hasPermissions('pld.select')) {
  items.push({
    title: 'catalogs',
    items: navCatalogsItems,
  });
}

if (hasPermissions('pld.select')) {
  items.push({
    title: 'Alertamiento',
    items: navWarningsItems,
  });
}

if (hasPermissions('pld.select')) {
  items.push({
    title: 'Análisis',
    items: navAnalistItems,
  });
}

if (hasPermissions('pld.select')) {
  items.push({
    items: [
      {
        href: '/pld/reports/calendar',
        title: 'calendar',
      },
      {
        href: '/pld/reports/internal',
        title: 'internal',
      },
    ],
    title: 'reports',
  });
}

export default items;
